<script setup lang="ts">
import type { PropType } from 'vue'
import type {
  AdminConfiguratorEventsType,
  AdminConfiguratorTemplateType,
  AdminConfiguratorType,
} from '@/entities/Cabinet'
import { useModel } from './../model/model'
import { cloneDeep } from 'lodash'

const props = defineProps({
  item: {
    type: Object as PropType<AdminConfiguratorTemplateType>,
    required: false,
  },
  configs: {
    type: Array as PropType<AdminConfiguratorType[]>,
    required: false,
  },
  events: {
    type: Array as PropType<AdminConfiguratorEventsType[]>,
    required: false,
  },
})

const model = useModel()

/**
 * Добавляем в редактирование шаблон
 */
const clickHandler = () => {
  if (props.configs && props.events) {
    model.data = cloneDeep(model.fields)

    props.configs.forEach((item) => {
      if (item.pin_number > 26) return

      const eventName =
        props.events?.find((event) => event.id === item.device_event_type_id)?.event_type || ''

      model.data.template.push({
        pin: item.pin_number,
        event: item.device_event_type_id,
        type_name: eventName,
      })
    })
  } else {
    model.data = cloneDeep(props.item || model.fields)
  }

  model.openForm = true
}
</script>

<template>
  <span @click.prevent="clickHandler">
    <slot />
  </span>
</template>
